import * as R from 'ramda';
import { CustomError } from '../../common/errors';
import { Validation, Step, ValidationStatus, ValidationStepStatus } from '../../services/validation';

export default class ValidationError extends CustomError {
  public errorCodes: string[];

  public isFailed: boolean;

  public isStepInvalid: boolean;

  constructor(message: string, isFailed: boolean, errorCodes: string[], nestedError?: Error) {
    super(message, nestedError);
    this.errorCodes = errorCodes;
    this.isFailed = isFailed;
    this.isStepInvalid = !isFailed;
  }

  // A validation is in error state if the overall status is failed or if any of the steps are invalid
  static isInErrorState(validation: Validation): boolean {
    return (
      validation.status === ValidationStatus.failed ||
      R.any((step: Step) => step.status === ValidationStepStatus.invalid, validation.steps)
    );
  }

  static from(validation: Validation): ValidationError {
    const validationFailed = validation.status === ValidationStatus.failed;
    // flatten all error codes into a single array
    const errorCodes = R.flatten([
      validation.errorCodes || [],
      ...R.map((step: Step) => step.errorCodes || [], validation.steps),
    ]);
    return new ValidationError(`Validation failed: ${validation.id}`, validationFailed, R.uniq(errorCodes));
  }
}

export const isValidationFailedError = (error: CustomError): boolean => {
  return R.is(ValidationError, error);
};
